import { Variants } from 'framer-motion';

const validColor = '#ffffff';
const errorColor = '#ffcfcf';

export const fadedown = {
  visible: { opacity: 1, y: 0 },
  hidden: { opacity: 0, y: -100 }
};

export const fadein = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 }
};

export const item = {
  visible: { opacity: 1, x: 0 },
  hidden: { opacity: 0, x: -100 }
};

export const shake: Variants = {
  valid: {
    translateX: 0,
    backgroundColor: validColor
  },
  invalid: {
    translateX: [0, -10, 10, -10, 10, 0],
    backgroundColor: errorColor
  }
};
